// clearance-form-input-handler.js
// Utility functions for handling input changes in the clearance form.

import { updateCombinationSVG } from './clearance-form-svg.js';

// Utility: debounce wrapper
function debounce(fn, delay) {
   let timer = null;
   return (...args) => {
      clearTimeout(timer);
      timer = setTimeout(() => fn(...args), delay);
   };
}

// Setup function: binds to all relevant input changes
// inside clearance-input-handler.js
export function setupInputChangeHandlers(handleInputChangeFn) {
   const handleChangeDebounced = debounce((unitIndex) => {
      handleInputChangeFn(unitIndex);
   }, 1000);

   $(document).on('change blur', '.accordion input', function () {
      const $unitPane = $(this).closest('.clearance-unit-pane');
      const id = $unitPane.attr('id');
      let unitIndex = 0;

      if (id && id.startsWith('unit-')) {
         unitIndex = parseInt(id.split('-')[1], 10);
      }

      handleChangeDebounced(unitIndex);
   });

   // Event handler for UNIT change tab clicks and input changes - bind to document to handle dynamically added tabs
   $(document).on('click', '.unit-tab-btn', function () {
      const unitIndex = $(this).data('unit-index');

      // Init changes, reset the active SVG tab to first SVG view
      setDiagramView(unitIndex, 'unit-side');
      handleInputChangeFn(unitIndex);
   });
}

//
// Register handlers for controls that are dynamically added to the page
// Static binding wont work for dynamically added elements - need to bind to document
//
export function setupDynamicHandlers() {
   // Handle SVG view switch button clicks in the unit sections
   $(document).on('click', '.btn-group button[data-view-mode]', function () {
      const $btn = $(this);
      const unitIndex = $btn.data('unit-index');
      const viewMode = $btn.data('view-mode');
      //console.log(`Switching to view mode: ${viewMode} for unit index: ${unitIndex}`);

      setDiagramView(unitIndex, viewMode);
      refreshDiagramView(unitIndex, viewMode);
   });
}

// Shared helper to set any diagram view mode for a given unit
function setDiagramView(unitIndex, viewMode) {
   const $container = $(`#unit-diagram-svg-${unitIndex}`).closest('.col');

   // Step 1: Activate the selected button
   $container.find('.svg-button').removeClass('active');
   $container.find(`.svg-button[data-view-mode="${viewMode}"]`).addClass('active');

   // Step 2: Show selected view, hide others
   $container.find('.view-pane').addClass('d-none');
   $container.find(`.view-pane[data-view-mode="${viewMode}"]`).removeClass('d-none');

   // Step 3: Update the title
   const diagramTitleMap = {
      'unit-side': 'Unit Dimensions',
      'combo-top': 'Combination Top View',
      'combo-side': 'Combination Side View',
   };
   const titleText = diagramTitleMap[viewMode] || 'View';
   $(`#diagram-title-${unitIndex}`).text(titleText);
}

// Refresh the SVG view for a given unit and view mode
export function refreshDiagramView(unitIndex, viewMode, forceClear = false) {
   // only refresh the combination diagram if the view is not unit-side
   // the side of unit diagram is refreshed on input change
   if (viewMode !== 'unit-side') {
      const formValues = buildClearanceInputJson();
      updateCombinationSVG(unitIndex, viewMode, formValues, forceClear);
   }
}

// Returns the currently selected view mode (e.g. 'unit-side', 'combo-top', 'combo-side')
export function getCurrentDiagramView(unitIndex) {
   const $container = $(`#unit-diagram-svg-${unitIndex}`).closest('.col');

   const $activeBtn = $container.find('.svg-button.active');
   if ($activeBtn.length === 0) return null;

   return $activeBtn.data('view-mode') || null;
}

/* * Build the input JSON for the clearance form based on current values.
 * This is used to send data to the server for rendering SVGs and running collision checks.
 * Returns an object with the vehicle type and units.
 */
export function buildClearanceInputJson() {
   const units = [];
   // Get the vehicle type from the dropdown
   const vehicleType = $('#vehicle-type option:selected').text();

   // Loop through each unit tab-pane
   $('.clearance-unit-pane').each(function () {
      const $unitPane = $(this);
      const unitIndex = $unitPane.attr('id').split('-')[1];
      const unitType = $unitPane.data('unit-type');

      if (!unitType) return; // Skip tabs with no data-unit-type

      const unitData = {
         unitType,
         unitId: `unit-${unitIndex}`,
      };

      $unitPane.find('[data-field]').each(function () {
         const $field = $(this);
         const fieldName = $field.data('field');
         if (!fieldName) return;

         if ($field.attr('type') === 'checkbox') {
            unitData[fieldName] = $field.prop('checked');
         } else {
            const val = $field.val();
            unitData[fieldName] = val === '' ? null : parseFloat(val);
         }
      });

      units.push(unitData);
   });

   return {
      name: vehicleType,
      units,
   };
}
